module.exports = __webpack_public_path__ + "static/media/Prev.67bfa0a5.svg";